import React, { useEffect } from "react";
import { Box, Container, Typography, Grid, Paper } from "@mui/material";
import "./PlanApproval.css";
import buildingSketch from "../../assets/images/DesignDiagram.jpg";
import { planApprovalServicesData } from "../../data/ServicesData";

export default function PlanApproval() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box className="plan-approval-container">
      {/* Header Section */}
      <Box
        className="header-section"
        sx={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.9)), url(${buildingSketch})`,
        }}
      >
        <Container>
          <Typography variant="h3" component="h1" className="header-title">
            Plan Approval
          </Typography>
        </Container>
      </Box>

      <Container className="content-container">
        {/* Intro Section */}
        <Box className="intro-section">
          <Typography variant="h4" gutterBottom className="intro-title">
            House Plan Approval Process
          </Typography>
          <Box
            sx={{
              width: "60px",
              height: "4px",
              backgroundColor: "#4285f4",
              margin: "0 auto 24px auto",
            }}
          />
          <Typography variant="body1" className="intro-text">
            At VR Builders and Promoters, we understand that the approval of
            your house plan is a critical step in bringing your vision to life.
            Our team is here to guide you through the entire process, ensuring
            that all required permits and approvals are obtained in a timely
            manner, and that your project complies with local regulations,
            zoning laws, and building codes.
          </Typography>
        </Box>

        <Grid item xs={12} lg={9}>
          <Grid container spacing={4} className="features-grid-container">
            {planApprovalServicesData.map((feature, index) => (
              <Grid item xs={12} md={6} lg={6} key={index}>
                <Paper elevation={0} className="feature-card">
                  <Box
                    className="feature-icon"
                    sx={{ color: feature.iconColor }}
                  >
                    {feature.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    component="h3"
                    gutterBottom
                    className="feature-title"
                  >
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" className="feature-text">
                    {feature.text}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
